<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">مزودين الخدمة</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/providers">مزودين الخدمة</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">عرض التفاصيل</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10">
            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
            <mainLoader v-if="mainLoading" />
            <ProvidersForm v-if="!mainLoading && checkAccess('providers_update')" 
              cardTitle="عرض التفاصيل" 
              :dataRow="row" 
              :statusObject="statusChoices" 
              :specializationList="specializationList" 
              :key="'form-' + row?.id"
              @reloadProvider="silentReload"
            />
            <ProvidersView v-if="!mainLoading && !checkAccess('providers_update')" 
              cardTitle="عرض التفاصيل" 
              :dataRow="row" 
              :statusObject="statusChoices" 
              :specializationList="specializationList"
              :key="'form-' + row?.id" 
              @reloadProvider="silentReload"
            />
            <AdminNotesPanel
              v-show="!mainLoading"
              modelName="Providers"
              :recordId="id"
            />
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { checkAccess } from '@/helpers/tools';
import ProvidersForm from './form.vue';
import ProvidersView from './view.vue';
import AdminNotesPanel from '../admin_notes/adminNotesPanel.vue';

export default {
  name: 'ProvidersUpdate',
  components: {
    ProvidersForm, ProvidersView, AdminNotesPanel
  },
  data(){
    return {
      id: this.$route.params.id,
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      row: null,
      statusChoices: {},
      specializationList: [],
    }
  },
  methods: {
    checkAccess,
    getRowData(){
      this.mainLoading = true;
      this.$http.get(`/api/admin/providers/retrieve/${this.id}`).then(({data}) => {
        this.row = data.row;
        this.statusChoices = data.statusChoices;
        this.specializationList = data.specializationList;
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    async silentReload(){
      const { data } = await this.$http.get(`/api/admin/providers/retrieve/${this.id}`);
      this.row = data.row;
    }
  },
  created(){
    this.getRowData();
  }
}
</script>